import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles, categoryMap } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const catInfo = categoryMap[slug || ""];
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!catInfo) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex flex-col items-center justify-center pt-20">
          <span className="w-16 h-16 flex items-center justify-center mb-4">
            <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
          </span>
          <h1 className="text-2xl font-heading font-bold text-foreground-800">分类未找到</h1>
          <Link
            to="/"
            className="mt-6 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
        </main>
        <Footer />
      </>
    );
  }

  const otherCategories = Object.entries(categoryMap).filter(([key]) => key !== slug);

  return (
    <>
      <Navbar />

      {/* Schema.org CollectionPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: `${catInfo.name} - 51黑料网`,
            url: `http://afvhue.cn/category/${slug}`,
            description: `查看${catInfo.name}下的全部爆料文章`,
          }),
        }}
      />

      {/* Hero - Category */}
      <section className="relative bg-background-100/80 pt-24 pb-12 md:pb-16">
        <div className="px-4 md:px-6 max-w-6xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 mb-5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${catInfo.icon} text-accent-600 text-xs`}></i>
            </span>
            <span className="text-xs font-medium text-accent-700 tracking-wide">分类浏览</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-950">
            {catInfo.name}<span className="text-primary-600">爆料</span>
          </h1>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            查看最新{catInfo.name}爆料内容，51黑料网为您提供真实、及时、深度的独家资讯
          </p>
        </div>
      </section>

      {/* Grid - Category articles */}
      <section className="bg-background-50 py-12 md:py-16">
        <div className="px-4 md:px-6 max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
              最新<span className="text-primary-600">{catInfo.name}</span>
            </h2>
            <p className="mt-1 text-sm text-foreground-400">
              共 {categoryArticles.length} 篇爆料文章
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {categoryArticles.map((article, idx) => (
              <ArticleCard
                key={article.id}
                article={article}
                variant={idx === 0 ? "featured" : "default"}
              />
            ))}
          </div>

          {categoryArticles.length === 0 && (
            <div className="text-center py-20">
              <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-inbox-line text-4xl text-foreground-300"></i>
              </span>
              <p className="text-foreground-400">暂无该分类的爆料文章</p>
            </div>
          )}
        </div>
      </section>

      {/* Feature Grid - Other categories */}
      <section className="bg-background-100/50 py-12 md:py-16">
        <div className="px-4 md:px-6 max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
              探索更多<span className="text-accent-600">分类</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-400">发现更多你感兴趣的内容</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {otherCategories.map(([key, info]) => (
              <Link
                key={key}
                to={`/category/${key}`}
                className="group relative aspect-[3/2] rounded-2xl overflow-hidden cursor-pointer hover:scale-[1.01] transition-transform duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-foreground-900/60 to-foreground-900/90 group-hover:from-foreground-900/50 group-hover:to-foreground-900/80 transition-colors"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                  <span className="w-14 h-14 flex items-center justify-center mb-3">
                    <i className={`${info.icon} text-3xl`}></i>
                  </span>
                  <h3 className="text-xl font-heading font-bold">{info.name}</h3>
                  <p className="mt-1 text-sm text-white/70">
                    {articles.filter((a) => a.category === key).length} 篇爆料
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
